import React from "react";
import { TextField, Tooltip, Box } from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import TinyEditor from "src/components/ckeditor/Ckeditor";

const SomeThingElseExercisesUI = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  isHistory,
  mainindex,
  handleAdd,
  handleMouseLeave,
  handleDelete,
  memueOptions,
}) => {
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index][name] = value;

    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleChangeDes = (value) => {
    const list = [...addArray];
    list[mainindex]["description"] = value;
    setaddArray(list);
    setModalChangeExe(true);
  };

  let workout_data = addArray[mainindex];

  return (
    <div className="my-2">
      <div className="characters mt-2">
        <div
          style={{
            width: "100%",
            padding: "1px",
            position: "relative",
          }}
        >
          <div
            className=" my-1 workout-set-card w-100"
            onMouseEnter={() => handleMouseLeave()}
            style={{
              width: "100%",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div className=" cross-icon d-flex justify-content-end">
              <>
                <Tooltip title="Remove Exercise">
                  <RemoveCircleOutlineIcon
                    onClick={() => handleDelete(mainindex)}
                    className="diary-icon-remove"
                  />
                </Tooltip>
              </>

              <Tooltip title="Add Exercise">
                <AddCircleOutlineIcon
                  onClick={() => handleAdd(mainindex)}
                  className="diary-icon-add"
                />
              </Tooltip>
              <CustomPopoverSection
                menu={memueOptions(mainindex)}
                data={mainindex}
              />
            </div>
            <Box
              sx={{
                position: "relative",
                width: "100%",
              }}
              onMouseEnter={() => handleMouseLeave()}
            >
              <div className="row" onMouseEnter={() => handleMouseLeave()}>
                <div
                  className={`col-sm-12 ${
                    isHistory ? "col-md-6" : "col-md-7"
                  } col-lg-7 d-flex align-items-center  mt-2 mt-md-0 mt-lg-0`}
                >
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    placeholder="Name"
                    value={workout_data?.title || ""}
                    name="title"
                    onChange={(e) => handleChange(e, mainindex)}
                    InputLabelProps={{
                      className: "textfiels-input-label",
                      shrink: true,
                      style: { fontSize: "14px" },
                    }}
                    label="Name"
                    InputProps={{
                      className: "textfiels-input-value",
                      style: {
                        fontSize: "13px",
                      },
                    }}
                    sx={{
                      borderRadius: "5px",
                      fontSize: "13px",
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <div className="col-12 mt-3">
                <h4>Description</h4>
                <TinyEditor
                  setDetailDescription={handleChangeDes}
                  detailDescriptionCk={workout_data?.description}
                />
              </div>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SomeThingElseExercisesUI;
